import { AlbaranReadingFiltersDtoProps } from "api/DTOs/AlbaranReadingFiltersDto"
import { PedidoReadingFiltersDtoProps } from "api/DTOs/PedidoReadingFiltersDto"
import { PresupuestoReadingFiltersDtoProps } from "api/DTOs/PresupuestoReadingFiltersDto"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import convertirDocumentoRedirect from "features/Crear/pages/FormCreacionDocumento/hooks/ConvertirDocumento/ConvertirDocumento"
import { useSelector } from "hooks/useSelector"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { useCallback } from "react"
import { useHistory } from "react-router-dom"
import { globalSelector } from "routes/globalSlice"

export const useConvertirDocumentoRedirect = () => {
  const history = useHistory()
  const { activeCompany } = useUsuarioEmpresaActiva()
  const { usuarioByCurrent } = useUsuarioByCurrent()
  const { formasPago, tiposImpuestosGenerales } = useSelector(globalSelector)
  const empresaActiva = usuarioByCurrent?.empresaActiva

  const handleConvertirDocumento = useCallback(
    async (
      rowData:
        | PresupuestoReadingFiltersDtoProps
        | PedidoReadingFiltersDtoProps
        | AlbaranReadingFiltersDtoProps,
      finalType: string
    ) => {
      try {
        if (rowData.tipoDocumento && rowData.id) {
          await convertirDocumentoRedirect({
            initialType: rowData.tipoDocumento,
            finalType,
            documentoId: rowData.id,
            fieldValue: {
              id: activeCompany.id,
              logo: activeCompany.logo,
              logoAsBase64: activeCompany.logoAsBase64,
              ...(empresaActiva !== undefined && { ...empresaActiva }),
            },
            push: history.push,
            formasPago,
            tiposImpuestosGenerales,
          })
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error al convertir el documento:", error)
      }
    },
    [activeCompany, empresaActiva, formasPago, tiposImpuestosGenerales, history]
  )

  return { handleConvertirDocumento }
}
